import React from "react";
import RouterErrorPage from "./RouterErrorPage";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Error caught by ErrorBoundary:", error, errorInfo);
        // qui potrei loggare al database
        this.setState({ error, errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return (
                <RouterErrorPage
                    title={this.state.error?.message || "Errore inaspettato"}
                    details={this.state.errorInfo?.componentStack || this.state.error?.stack}
                />
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
